import React from "react";
import { createContext, useContext, useState } from "react";

const ReplayModeContext = createContext(undefined);

export const ReplayModeContextProvider = ({ children }) => {
  const [replayModeConfig, setReplayModeConfig] = useState({
    isReplayMode: false, 
    isPlaying: false,
    isRealTime: true,
    replaySpeed: 1,
    replayPoints: [], // [{value: timestamp, label: string}]
    currentTimestamp: null,
    currentPoint: null,
    displayWhatList: ['locates', 'gps', 'streets'],
  });

  return (
    <ReplayModeContext.Provider
      value={{
        replayModeConfig,
        setReplayModeConfig,
      }}>
      {children}
    </ReplayModeContext.Provider>
  );
};

export const useReplayMode = () => {
  const context = useContext(ReplayModeContext);
  if (!context) {
    throw new Error("useReplayMode must be used within an ReplayModeProvider");
  }
  return context;
};
